// extracted by mini-css-extract-plugin
export default {"login":"styles_login__CPZWB","forms":"styles_forms__GvA9n"};